import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, Typography, Box, Accordion, AccordionSummary,
  AccordionDetails, Chip, TextField, InputAdornment, Button, Grid,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import GroupsIcon from '@mui/icons-material/Groups';
import CarRentalIcon from '@mui/icons-material/CarRental';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PaymentIcon from '@mui/icons-material/Payment';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const C = {
  purple:    '#552583',
  purpleDark:'#33154f',
  purpleLight:'#7a3aad',
  gold:      '#FDB927',
  bg:        '#E4F0F6',
  white:     '#ffffff',
  text:      '#1a1a1a',
  textSoft:  '#4a4a4a',
  textMuted: '#7a7a7a',
};

const categories = [
  { id: 'all',        label: 'Tout',        icon: <HelpOutlineIcon  sx={{ fontSize: 18 }} /> },
  { id: 'general',    label: 'Général',     icon: <AccountCircleIcon sx={{ fontSize: 18 }} /> },
  { id: 'restaurant', label: 'Restauration',icon: <RestaurantIcon   sx={{ fontSize: 18 }} /> },
  { id: 'carpool',    label: 'Covoiturage', icon: <GroupsIcon       sx={{ fontSize: 18 }} /> },
  { id: 'car-rental', label: 'Location',    icon: <CarRentalIcon    sx={{ fontSize: 18 }} /> },
  { id: 'vtc',        label: 'VTC',         icon: <DirectionsCarIcon sx={{ fontSize: 18 }} /> },
  { id: 'delivery',   label: 'Livraison',   icon: <LocalShippingIcon sx={{ fontSize: 18 }} /> },
  { id: 'payment',    label: 'Paiement',    icon: <PaymentIcon      sx={{ fontSize: 18 }} /> },
  { id: 'partner',    label: 'Partenaires', icon: <HandshakeIcon    sx={{ fontSize: 18 }} /> },
];

const faqData = [
  { category: 'general',    question: "Qu'est-ce qu'Usafiri ?",                            answer: "Usafiri est la première plateforme multi-services de Mayotte. Nous regroupons la restauration, le covoiturage, la location de véhicules, le VTC, la logistique et les courses en un seul endroit. Notre mission est de digitaliser les services locaux pour offrir une expérience moderne et accessible à tous les Mahorais." },
  { category: 'general',    question: "Comment créer un compte Usafiri ?",                  answer: "Rendez-vous sur la page d'inscription, remplissez vos informations personnelles (nom, prénom, email, téléphone) et créez un mot de passe sécurisé. Vous recevrez un email de confirmation pour activer votre compte. L'inscription est gratuite et ne prend que 2 minutes." },
  { category: 'general',    question: "Usafiri est-il disponible partout à Mayotte ?",     answer: "Oui, Usafiri couvre l'ensemble de Mayotte, de Mamoudzou à Dzaoudzi en passant par Koungou, Dembéni, Sada et toutes les communes de l'île. La disponibilité de certains services peut varier selon les zones, mais nous étendons constamment notre couverture." },
  { category: 'general',    question: "L'application est-elle gratuite ?",                 answer: "L'inscription et l'utilisation de la plateforme sont entièrement gratuites pour les utilisateurs. Vous ne payez que les services que vous commandez (repas, trajets, locations, etc.). Aucun frais caché ni abonnement requis." },
  { category: 'restaurant', question: "Comment commander un repas sur Usafiri ?",          answer: "Parcourez les restaurants disponibles, consultez leurs menus, ajoutez vos plats au panier et validez votre commande. Un livreur Usafiri viendra chercher votre commande au restaurant et vous la livrera directement. Vous pouvez suivre votre livraison en temps réel." },
  { category: 'restaurant', question: "Quel est le délai de livraison moyen ?",            answer: "Le délai de livraison moyen est de 25 à 35 minutes, selon la distance entre le restaurant et votre adresse, ainsi que la préparation du repas. Vous pouvez voir une estimation du temps de livraison avant de valider votre commande." },
  { category: 'restaurant', question: "Y a-t-il un minimum de commande ?",                 answer: "Le minimum de commande varie selon le restaurant. Il est indiqué sur la page de chaque établissement. En général, le minimum se situe entre 8 € et 15 €. Les frais de livraison sont calculés en fonction de la distance." },
  { category: 'restaurant', question: "Puis-je annuler ma commande ?",                     answer: "Vous pouvez annuler votre commande tant que le restaurant n'a pas commencé la préparation. Une fois la préparation en cours, l'annulation n'est plus possible. En cas de problème avec votre commande, contactez notre service client pour un remboursement." },
  { category: 'carpool',    question: "Comment fonctionne le covoiturage sur Usafiri ?",   answer: "Les conducteurs publient leurs trajets avec le lieu de départ, la destination, la date, l'heure et le prix par passager. Les passagers recherchent un trajet correspondant à leur besoin et réservent une place. Le paiement est sécurisé via la plateforme." },
  { category: 'carpool',    question: "Comment est fixé le prix d'un covoiturage ?",       answer: "Le conducteur fixe librement son prix par passager. Usafiri recommande un tarif basé sur la distance et le prix du carburant à Mayotte, mais le conducteur peut l'ajuster. En moyenne, un trajet coûte 70% moins cher qu'un taxi." },
  { category: 'carpool',    question: "Que se passe-t-il si le conducteur annule ?",       answer: "En cas d'annulation par le conducteur, vous êtes intégralement remboursé. Nous vous proposons automatiquement des trajets alternatifs si disponibles. Les conducteurs qui annulent fréquemment peuvent voir leur compte restreint." },
  { category: 'carpool',    question: "Les conducteurs sont-ils vérifiés ?",               answer: "Oui, chaque conducteur doit fournir une pièce d'identité, un permis de conduire valide et les documents du véhicule (carte grise, assurance). Ces documents sont vérifiés par notre équipe avant l'activation du compte." },
  { category: 'car-rental', question: "Comment louer un véhicule sur Usafiri ?",           answer: "Recherchez un véhicule par dates, type et budget. Consultez les détails du véhicule (photos, équipements, conditions), puis réservez en ligne. Le véhicule sera mis à disposition par notre partenaire loueur aux dates convenues." },
  { category: 'car-rental', question: "Quels documents sont nécessaires pour louer ?",     answer: "Vous devez présenter un permis de conduire valide (depuis au moins 1 an), une pièce d'identité et un moyen de paiement. Certains véhicules peuvent nécessiter un permis depuis 2 ans minimum." },
  { category: 'car-rental', question: "L'assurance est-elle incluse ?",                    answer: "Oui, tous les véhicules en location incluent une assurance tous risques de base. Vous pouvez souscrire à des options complémentaires (protection zéro franchise, assistance 24h) pour une couverture maximale." },
  { category: 'vtc',        question: "Comment réserver un VTC ?",                         answer: "Indiquez votre point de départ et votre destination, choisissez le type de véhicule souhaité et confirmez votre course. Un chauffeur VTC professionnel viendra vous chercher. Vous pouvez réserver immédiatement ou planifier à l'avance." },
  { category: 'vtc',        question: "Quelle est la différence entre VTC et covoiturage ?", answer: "Le VTC est un service de transport privé avec chauffeur professionnel, disponible à la demande. Le covoiturage est un partage de trajet entre particuliers, planifié à l'avance. Le VTC est plus flexible mais plus coûteux que le covoiturage." },
  { category: 'delivery',   question: "Qui sont les livreurs Usafiri ?",                   answer: "Nos livreurs sont des professionnels recrutés et formés par Usafiri. Ils assurent la livraison de toutes les commandes restaurant et courses de la plateforme. Chaque livreur est identifié, équipé et géolocalisé pour garantir un service fiable." },
  { category: 'delivery',   question: "Puis-je suivre ma livraison en temps réel ?",       answer: "Oui, dès qu'un livreur prend en charge votre commande, vous pouvez suivre son parcours en temps réel sur la carte. Vous recevez également des notifications à chaque étape : prise en charge, en route, arrivée imminente." },
  { category: 'delivery',   question: "Quels sont les frais de livraison ?",               answer: "Les frais de livraison varient en fonction de la distance entre le point de retrait et votre adresse. Ils sont clairement affichés avant la validation de votre commande. En moyenne, comptez entre 2 € et 6 € selon la distance." },
  { category: 'payment',    question: "Quels moyens de paiement sont acceptés ?",          answer: "Usafiri accepte les paiements par carte bancaire (Visa, Mastercard) et par virement bancaire. Tous les paiements sont sécurisés et chiffrés. Vous pouvez enregistrer votre carte pour des paiements plus rapides." },
  { category: 'payment',    question: "Mes données bancaires sont-elles sécurisées ?",     answer: "Absolument. Nous utilisons un chiffrement SSL de bout en bout et nos systèmes de paiement sont conformes aux normes PCI-DSS. Vos données bancaires ne sont jamais stockées sur nos serveurs — elles sont gérées par notre prestataire de paiement certifié." },
  { category: 'payment',    question: "Comment obtenir un remboursement ?",                answer: "En cas de problème avec une commande, contactez notre service client. Après vérification, le remboursement est effectué sous 3 à 5 jours ouvrés sur votre moyen de paiement initial. Pour les annulations anticipées, le remboursement est immédiat." },
  { category: 'partner',    question: "Comment devenir partenaire Usafiri ?",              answer: "Rendez-vous sur la page d'inscription partenaire. Usafiri accompagne les entreprises locales (restaurants, commerces, loueurs de véhicules) dans leur digitalisation. Remplissez le formulaire et notre équipe étudiera votre candidature sous 48h." },
  { category: 'partner',    question: "Quels types d'entreprises peuvent devenir partenaires ?", answer: "Nous accueillons les restaurants, commerces et magasins, sociétés de location de véhicules, sociétés VTC et entreprises de logistique/transport. Chaque partenariat est adapté à votre activité avec des outils spécifiques." },
  { category: 'partner',    question: "Quelles sont les commissions Usafiri ?",            answer: "Les commissions varient selon le type de partenariat : 15% pour la restauration, 12% pour les commerces, et 20% pour la location de véhicules. Ces commissions couvrent l'accès à la plateforme, la visibilité, le marketing et la gestion de la livraison." },
  { category: 'partner',    question: "Comment suis-je payé en tant que partenaire ?",     answer: "Les paiements sont effectués par virement bancaire sur votre IBAN, selon un cycle hebdomadaire ou mensuel selon votre choix. Vous disposez d'un tableau de bord détaillé pour suivre vos revenus, commandes et performances en temps réel." },
  { category: 'partner',    question: "Usafiri gère-t-il la livraison pour mon restaurant ?", answer: "Oui ! C'est l'un des avantages majeurs d'Usafiri. Nos livreurs professionnels prennent en charge la livraison de toutes vos commandes. Vous n'avez qu'à préparer les commandes, nous nous occupons du reste." },
];

const FAQ = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (_, isExpanded) => setExpanded(isExpanded ? panel : false);

  const filteredFAQs = faqData.filter((faq) => {
    const matchesCategory = activeCategory === 'all' || faq.category === activeCategory;
    const matchesSearch = searchQuery === '' ||
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const getCategoryCount = (catId) =>
    catId === 'all' ? faqData.length : faqData.filter(f => f.category === catId).length;

  return (
    <Box sx={{ bgcolor: C.bg, minHeight: '100vh' }}>

      {/* ── HERO ── */}
      <Box sx={{
        background: `linear-gradient(135deg, ${C.purpleDark} 0%, ${C.purple} 60%, ${C.purpleLight} 100%)`,
        pt: { xs: 8, md: 12 },
        pb: { xs: 8, md: 12 },
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""', position: 'absolute',
          top: '-40%', right: '-5%', width: '55%', height: '200%',
          background: `radial-gradient(ellipse, rgba(253,185,39,0.18) 0%, transparent 65%)`,
        },
        '&::after': {
          content: '""', position: 'absolute',
          bottom: 0, left: 0, right: 0, height: 80,
          background: `linear-gradient(to bottom, transparent, ${C.bg})`,
        },
      }}>
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Box sx={{ textAlign: 'center' }}>

            {/* Badge */}
            <Box sx={{
              display: 'inline-flex', alignItems: 'center', gap: 1.5,
              px: 3, py: 1, borderRadius: '50px', mb: 4,
              bgcolor: 'rgba(253,185,39,0.15)',
              border: '1px solid rgba(253,185,39,0.35)',
            }}>
              <SupportAgentIcon sx={{ color: C.gold, fontSize: 20 }} />
              <Typography sx={{ color: C.gold, fontSize: '0.78rem', fontWeight: 700, letterSpacing: '0.15em' }}>
                CENTRE D'AIDE
              </Typography>
            </Box>

            <Typography variant="h1" sx={{
              color: 'white', fontWeight: 900, mb: 2,
              fontSize: { xs: '2rem', sm: '2.8rem', md: '4rem' },
              lineHeight: 1.1,
            }}>
              QUESTIONS{' '}
              <Box component="span" sx={{
                background: `linear-gradient(135deg, ${C.gold}, #ffd060)`,
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              }}>
                FRÉQUENTES
              </Box>
            </Typography>

            <Typography sx={{
              color: 'rgba(255,255,255,0.65)',
              fontSize: { xs: '0.95rem', md: '1.1rem' },
              maxWidth: 560, mx: 'auto', mb: 5, lineHeight: 1.8,
            }}>
              Trouvez rapidement des réponses à vos questions sur nos services,
              les paiements, les livraisons et le partenariat.
            </Typography>

            {/* Barre de recherche */}
            <Box sx={{ maxWidth: 560, mx: 'auto' }}>
              <TextField
                fullWidth
                placeholder="Rechercher une question..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: 'rgba(255,255,255,0.5)' }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    background: 'rgba(255,255,255,0.1)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255,255,255,0.2)',
                    borderRadius: '16px',
                    color: 'white',
                    '& input::placeholder': { color: 'rgba(255,255,255,0.4)', opacity: 1 },
                    '&:hover': { border: `1px solid rgba(253,185,39,0.5)` },
                    '&.Mui-focused': { border: `1px solid ${C.gold}`, boxShadow: `0 0 24px rgba(253,185,39,0.2)` },
                  },
                }}
              />
            </Box>
          </Box>
        </Container>
      </Box>

      {/* ── FILTRES ── */}
      <Container maxWidth="lg" sx={{ mt: 6, mb: 2 }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, justifyContent: 'center', mb: 6 }}>
          {categories.map((cat) => {
            const active = activeCategory === cat.id;
            return (
              <Chip
                key={cat.id}
                icon={cat.icon}
                label={`${cat.label} (${getCategoryCount(cat.id)})`}
                onClick={() => setActiveCategory(cat.id)}
                sx={{
                  px: 1.5, py: 2.5,
                  fontSize: '0.82rem', fontWeight: 600, borderRadius: '12px',
                  border: '2px solid',
                  borderColor: active ? C.purple : 'rgba(85,37,131,0.15)',
                  bgcolor: active ? C.purple : 'white',
                  color: active ? 'white' : C.textSoft,
                  boxShadow: active ? `0 4px 16px rgba(85,37,131,0.25)` : '0 2px 8px rgba(85,37,131,0.06)',
                  transition: 'all 0.25s ease',
                  '& .MuiChip-icon': { color: active ? 'white' : C.purple },
                  '&:hover': {
                    bgcolor: active ? C.purpleLight : `rgba(85,37,131,0.06)`,
                    borderColor: C.purple,
                    color: active ? 'white' : C.purple,
                    transform: 'translateY(-2px)',
                    boxShadow: `0 6px 20px rgba(85,37,131,0.2)`,
                    '& .MuiChip-icon': { color: active ? 'white' : C.purple },
                  },
                }}
              />
            );
          })}
        </Box>

        {/* ── ACCORDÉONS ── */}
        <Box sx={{ mb: 10 }}>
          {filteredFAQs.length === 0 ? (
            <Box sx={{
              textAlign: 'center', py: 8, px: 3, borderRadius: '24px',
              bgcolor: 'white', border: `1px solid rgba(85,37,131,0.1)`,
              boxShadow: '0 4px 20px rgba(85,37,131,0.06)',
            }}>
              <HelpOutlineIcon sx={{ fontSize: 60, color: 'rgba(85,37,131,0.2)', mb: 2 }} />
              <Typography variant="h5" sx={{ color: C.textSoft, mb: 1, fontWeight: 700 }}>
                Aucun résultat trouvé
              </Typography>
              <Typography sx={{ color: C.textMuted }}>
                Essayez d'autres termes ou changez de catégorie
              </Typography>
            </Box>
          ) : (
            filteredFAQs.map((faq, index) => {
              const isOpen = expanded === index;
              return (
                <Accordion
                  key={index}
                  expanded={isOpen}
                  onChange={handleChange(index)}
                  sx={{
                    bgcolor: 'white',
                    border: '1px solid',
                    borderColor: isOpen ? C.purple : 'rgba(85,37,131,0.1)',
                    borderRadius: '16px !important',
                    mb: 1.5,
                    overflow: 'hidden',
                    transition: 'all 0.25s ease',
                    boxShadow: isOpen
                      ? `0 8px 32px rgba(85,37,131,0.15)`
                      : '0 2px 12px rgba(85,37,131,0.05)',
                    '&::before': { display: 'none' },
                    '&:hover': {
                      borderColor: C.purple,
                      boxShadow: `0 4px 20px rgba(85,37,131,0.1)`,
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon sx={{
                        color: isOpen ? C.purple : C.textMuted,
                        transition: 'color 0.25s',
                      }} />
                    }
                    sx={{
                      px: { xs: 2.5, md: 3.5 }, py: 0.5,
                      '& .MuiAccordionSummary-content': { my: 1.5, alignItems: 'center', gap: 2 },
                    }}
                  >
                    {/* Icône catégorie */}
                    <Box sx={{
                      display: { xs: 'none', sm: 'flex' },
                      alignItems: 'center', justifyContent: 'center',
                      width: 38, height: 38, borderRadius: '10px', flexShrink: 0,
                      bgcolor: isOpen ? `rgba(85,37,131,0.08)` : `rgba(85,37,131,0.04)`,
                      border: `1px solid ${isOpen ? 'rgba(85,37,131,0.2)' : 'rgba(85,37,131,0.08)'}`,
                      transition: 'all 0.25s',
                      '& svg': { color: isOpen ? C.purple : C.textMuted, fontSize: 18 },
                    }}>
                      {categories.find(c => c.id === faq.category)?.icon || <HelpOutlineIcon />}
                    </Box>
                    <Typography sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.9rem', md: '1rem' },
                      color: isOpen ? C.purple : C.text,
                      transition: 'color 0.25s',
                      lineHeight: 1.4,
                    }}>
                      {faq.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ px: { xs: 2.5, md: 3.5 }, pb: 3, pt: 0, pl: { sm: 9 } }}>
                    <Typography sx={{
                      color: C.textSoft, lineHeight: 1.9, fontSize: '0.92rem',
                      borderLeft: `3px solid ${C.gold}`, pl: 2,
                    }}>
                      {faq.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              );
            })
          )}
        </Box>
      </Container>

      {/* ── CONTACT ── */}
      <Box sx={{
        py: { xs: 8, md: 10 },
        background: `linear-gradient(135deg, ${C.purpleDark} 0%, ${C.purple} 100%)`,
        position: 'relative', overflow: 'hidden',
        '&::before': {
          content: '""', position: 'absolute',
          top: '-40%', right: '-10%', width: '60%', height: '200%',
          background: `radial-gradient(ellipse, rgba(253,185,39,0.15) 0%, transparent 65%)`,
        },
      }}>
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="h3" sx={{
              fontWeight: 800, color: 'white', mb: 2,
              fontSize: { xs: '1.6rem', md: '2.2rem' },
            }}>
              BESOIN D'AIDE ?
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.65)', maxWidth: 480, mx: 'auto', fontSize: '1rem' }}>
              Notre équipe est disponible pour répondre à toutes vos questions
            </Typography>
          </Box>

          <Grid container spacing={3} justifyContent="center" sx={{ mb: 6 }}>
            {[
              { icon: <EmailIcon sx={{ fontSize: 26 }} />, title: 'Email',     info: 'contact@usafiri.yt', sub: 'Réponse sous 24h' },
              { icon: <PhoneIcon sx={{ fontSize: 26 }} />, title: 'Téléphone', info: '0269 00 00 00',      sub: 'Lun-Sam, 8h-20h' },
              { icon: <AccessTimeIcon sx={{ fontSize: 26 }} />, title: 'Horaires', info: '7j/7',          sub: 'Service client disponible' },
            ].map((item, i) => (
              <Grid item xs={12} sm={4} key={i}>
                <Box sx={{
                  textAlign: 'center', p: 3.5, borderRadius: '20px',
                  bgcolor: 'rgba(255,255,255,0.07)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  backdropFilter: 'blur(20px)',
                  transition: 'all 0.25s ease',
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.12)',
                    border: `1px solid rgba(253,185,39,0.4)`,
                    transform: 'translateY(-4px)',
                    boxShadow: `0 12px 40px rgba(0,0,0,0.3)`,
                  },
                }}>
                  <Box sx={{
                    width: 56, height: 56, borderRadius: '14px', mx: 'auto', mb: 2,
                    bgcolor: 'rgba(253,185,39,0.15)',
                    border: `1px solid rgba(253,185,39,0.3)`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: C.gold,
                  }}>
                    {item.icon}
                  </Box>
                  <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', mb: 0.8 }}>
                    {item.title}
                  </Typography>
                  <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '1.05rem', mb: 0.4 }}>
                    {item.info}
                  </Typography>
                  <Typography sx={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.82rem' }}>
                    {item.sub}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          {/* CTA Partenaire */}
          <Box sx={{
            p: { xs: 3.5, md: 5 }, borderRadius: '24px',
            bgcolor: 'rgba(253,185,39,0.1)',
            border: `1px solid rgba(253,185,39,0.25)`,
            textAlign: 'center',
          }}>
            <Typography variant="h4" sx={{
              fontWeight: 800, color: 'white', mb: 1.5,
              fontSize: { xs: '1.2rem', md: '1.6rem' },
            }}>
              VOUS ÊTES PROFESSIONNEL ?
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.6)', mb: 3.5, maxWidth: 480, mx: 'auto', fontSize: '0.95rem' }}>
              Digitalisez votre activité avec Usafiri et rejoignez notre réseau de partenaires à Mayotte
            </Typography>
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate('/partner/register')}
              sx={{
                px: 5, py: 1.6, fontSize: '0.9rem',
                bgcolor: C.gold, color: C.purpleDark, fontWeight: 800,
                borderRadius: '14px', textTransform: 'none',
                boxShadow: `0 6px 24px rgba(253,185,39,0.4)`,
                '&:hover': { bgcolor: '#ffd060', transform: 'translateY(-2px)', boxShadow: `0 10px 32px rgba(253,185,39,0.55)` },
              }}
            >
              Devenir Partenaire
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default FAQ;
